import { useState } from "react";
import "@/App.css";
import { useLenis } from "@/hooks/useLenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import VideoModal from "@/components/VideoModal";
import ScrollVideoBackground from "@/components/ScrollVideoBackground";
import Hero from "@/components/sections/Hero";
import Problem from "@/components/sections/Problem";
import Capabilities from "@/components/sections/Capabilities";
import BuiltFor from "@/components/sections/BuiltFor";
import Integrations from "@/components/sections/Integrations";
import WhyNot from "@/components/sections/WhyNot";
import Pricing from "@/components/sections/Pricing";
import About from "@/components/sections/About";
import ClosingCTA from "@/components/sections/ClosingCTA";
import Contact from "@/components/sections/Contact";

function App() {
  useLenis();
  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <div className="min-h-screen font-sans text-ink antialiased">
      <ScrollVideoBackground />
      <Header />
      <main className="relative z-10">
        <Hero onPlay={() => setVideoOpen(true)} />
        <Problem />
        <Capabilities />
        <BuiltFor />
        <Integrations />
        <WhyNot />
        <Pricing />
        <About />
        <ClosingCTA />
        <Contact />
      </main>
      <Footer />
      <VideoModal open={videoOpen} onOpenChange={setVideoOpen} />
    </div>
  );
}

export default App;
